import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { AnimationDuration, getAnimationAppearDisappear } from '@examdojo/animation';
import { LoaderComponent } from '@examdojo/core/loader';
import { RoutingLoadingService } from './routing-loading.service';

@Component({
  selector: 'dojo-app-loader',
  imports: [LoaderComponent],
  template: `
    <div
      class="fullscreen-loader absolute z-[1000000] flex h-full w-full items-center justify-center"
      [class.visible]="state.showFullScreenLoader"
    >
      @if (state.showFullScreenLoader) {
        @if (state.isInitialRoutingLoading) {
          @defer (on timer(500ms)) {
            <dojo-loader [centered]="true" @appearDisappear />
          }
        } @else {
          @defer (on timer(100ms)) {
            <dojo-loader [centered]="true" @appearDisappear />
          }
        }
      }
    </div>
  `,
  styles: `
    .fullscreen-loader {
      background-color: rgba(255, 255, 255, 0);
      backdrop-filter: blur(0);
      -webkit-backdrop-filter: blur(0);
      pointer-events: none;
      transition:
        background-color 0.3s ease-in-out,
        backdrop-filter 0.3s ease-in-out,
        -webkit-backdrop-filter 0.3s ease-in-out;

      &.visible {
        background-color: rgba(255, 255, 255, 0.7);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        pointer-events: auto;
      }
    }

    :host-context(.dark) .fullscreen-loader.visible {
      background-color: rgba(25, 30, 41, 0.7);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [getAnimationAppearDisappear({ enter: AnimationDuration.Long })],
})
export class AppLoaderComponent {
  constructor(private readonly routingLoadingService: RoutingLoadingService) {}

  readonly state = connectState({
    showFullScreenLoader: this.routingLoadingService.showFullScreenLoader$,
    isInitialRoutingLoading: this.routingLoadingService.isInitialRoutingLoading$,
  });
}
